import React, { Fragment, useEffect, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import withStyles from '@mui/styles/withStyles';
import { useHistory } from "react-router-dom";
import clsx from "clsx";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import VideoLabelIcon from "@mui/icons-material/VideoLabel";
import CommentIcon from "@mui/icons-material/Comment";
import StepConnector from "@mui/material/StepConnector";
import ExtensionIcon from "@mui/icons-material/Extension";
import { Box, Grid, Paper, Button } from "@mui/material/";
import EventNoteIcon from "@mui/icons-material/EventNote";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import OpenInBrowserIcon from "@mui/icons-material/OpenInBrowser";
import Spinner from "../templates/Spinner";
import { RecursoItems } from "./RecursoItems";

import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Table from '@mui/material/Table';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import tableCellClasses from '@mui/material/TableCell';

import { validatePrintCertificate } from "../commons/utils";
import RenderFile from "../commons/renderFile/renderFile";
import EmberFile from "../commons/emberFile/emberFile";

import {
  findFases,
  findTramitedet,
  getCertificate,
} from "../../service/service.supersalud";
import Modal from "@mui/material/Modal";
import TramitesHistoria from "./TramitesHistoria";

// import 'react-vertical-timeline-component/style.min.css';
// import dataHistory from "./data";
// import { Chrono } from "react-chrono";
import { ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";

import { isAnalista } from "../commons/utils";
import { baseUrl } from "../../config/config";

const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    "& $line": {
      backgroundImage:
        "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
    },
  },

  completed: {
    "& $line": {
      backgroundImage:
        "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: "#eaeaf0",
    borderRadius: 1,
  },
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: "#ccc",
    zIndex: 1,
    color: "#fff",
    width: 50,
    height: 50,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
  },
  active: {
    backgroundImage:
      "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  },
  completed: {
    backgroundImage:
      "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
  },
  formGroup: {
    marginBottom: "10px",
  },
});

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },

}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    padding: "0px 0px",

  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 5,
  },
}));

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;
  const icons = {
    1: <OpenInBrowserIcon />,
    2: <GroupAddIcon />,
    3: <VideoLabelIcon />,
    4: <CommentIcon />,
    5: <ExtensionIcon />,
    6: <EventNoteIcon />,
    7: <EventNoteIcon />,
    8: <CheckCircleOutlineIcon />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[7]}
    </div>
  );
}

const TramitesDetails = (props) => {
  const { user, recActivo, userLogOut, userLoggedIn } = props;
  const { innerWidth: width /*, innerHeight: height*/ } = window;
  const history = useHistory();
  const classes = useStyles();
  const [tramite, setTramite] = useState(null);
  const [fases, setFases] = useState(null);
  const [loading, setLoading] = useState(true);
  const [dataHistoria, setDataHistoria] = useState(true);
  const [url, setUrl] = useState(undefined);
  const [expediente, setExpediente] = useState(undefined);
  // Fasa actual de Reclamo
  const [activeStep, setActiveStep] = useState(4);
  const logout = () => {
    userLogOut();
    history.push("/login");
  };
  const getFases = async () => {
    const resp = await findFases(user, logout, userLoggedIn)(recActivo.tipo_reclamo /* tipo_reclamo */);
    const resp_status = (resp || {}).status;
    if (resp_status === 200) {
      let results = await resp.json();
      const fase = results.findIndex((i) => i.name === recActivo.fase.nombre /* fase.nombre */);

      if (fase && fase === -1) {
        setActiveStep(0);
      } else {
        setActiveStep(fase);
      }
      if ((recActivo.fase.nombre /* fase.nombre */ == 'Archivado') && (recActivo.tipo_reclamo /* tipo_reclamo */ == 'APB')) {

        setActiveStep(1);
        setFases(
          [
            {
              "id": "f960f2c4-c19b-4dcb-915c-77f6ad51f087",
              "name": "Admisibilidad",
              "tipo": "APB",
              "descripcion": "Admisibilidad",
              "peso": 100,
              "etapas": []
            },
            {
              "id": "05947534-80c0-4902-ad9b-5577915b7ba7",
              "name": "Reclamo Archivado",
              "tipo": "APB",
              "descripcion": "Reclamo Archivado",
              "peso": 200,
              "etapas": []
            }
          ]);
      } else {
        setFases(results);
      }

    }
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const [open, setOpen] = React.useState(false);
  // const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const generateCertificado = async (reclamo) => {
    let aux = {
      ...reclamo,
      identifier: reclamo.run_rec,

    }
    const url = await getCertificate(user, logout, userLoggedIn)(aux);
    if (url) {
      setUrl(`data:application/pdf;base64,${url}`);
    }
  };

  const generateExpediente = async (datosexp) => {
    setExpediente(
      baseUrl +
      "/tramites/api/v1/pdfExpedienteView/" +
      datosexp.link_expediente +
      "/" +
      datosexp.run_rec +
      "/" +
      datosexp.folio
    );
    // const url = await PdfExpedienteView(datosexp);
    // console.log("urllog2")
    // console.log(url)
    // if (url) {
    //   setUrl(`data:application/pdf;base64,${url}`);
    // }
  };

  const getDetalleReclamo = async () => {
    const raw = JSON.stringify({
      rut: recActivo.run_rec, /* run_rec */
      folio: recActivo.folio, /* folio */
      ux: recActivo.ux, /* ux */
      monitoreo: true,
    });

    const resp = await findTramitedet(user, logout, userLoggedIn)(raw);
    const resp_status = await resp.status;
    setLoading(false);
    if (resp_status !== 200 && resp_status !== 401) {
 /*/*      userLogOut();
      return history.push("/login");*/ 
    }
    let { results } = await resp.json();

    const faseDescription = results[0].fase && results[0].fase.descripcion_fase;
    let faseHistoria = results[0].historia;

    if (typeof faseHistoria === "string") {
      faseHistoria = null;
    }
    setGenerateDataHistoria(results[0].historia);
    try {
      results = results.map((i) => ({
        ...i,
        fase: i.fase.nombre,
        historia: undefined,
      }));
    } catch (error) {
      console.log(error);
    }
    const printCertificate = validatePrintCertificate(results[0]);
    const cetificateTramite = results[0];
    const expedienteTramite = results[0];
    const expedienteTipo = results[0].ux;
    var expedientePrint =
      results[0].link_expediente !== undefined ? true : false;
    //console.log(results[0].link_expediente);
    if (expedientePrint === true) {
      //  console.log("expedientePrint");
      results[0].link_expediente.length > 0
        ? (expedientePrint = true)
        : (expedientePrint = false);
    }

    //console.log(expedientePrint);
    // results = results.map((i) => ({
    //   "Reclamante/Solicitante": i.nombre_solicitante,
    //   "Tipo de trámite": i.tramitacion,
    //   "Fecha Ingreso": i.fecha_ingreso,
    //   "Entidad requerida": i.reclamado,
    //   Materia: i.materia,
    //   "Fecha esperada de término": i.fecha_esperada_termino,
    // }));

    results = results.map((i) =>
      i.ux_type === "solicitud"
        ? {
          "Reclamante/Solicitante": i.nombre_solicitante,
          "Tipo de trámite": i.tramitacion,
          "Fecha Ingreso": i.fecha_ingreso,
          "Entidad requerida": i.reclamado,
          "Titulo/Especialidad": i.materia,
          /*             "Fecha aproximada de respuesta sin considerar Recursos":
                        i.fecha_esperada_termino, */
        }
        : {
          "Reclamante/Solicitante": i.nombre_solicitante,
          "Tipo de trámite": i.tramitacion,
          "Fecha Ingreso": i.fecha_ingreso,
          "Entidad requerida": i.reclamado,
          Materia: i.materia,
          /*             "Fecha aproximada de respuesta sin considerar Recursos":
                        i.fecha_esperada_termino, */
        }
    );
    setTramite({
      recursos: results,
      faseDescription,
      printCertificate,
      cetificateTramite,
      expedienteTramite,
      faseHistoria,
      expedienteTipo,
      expedientePrint,
    });
  };

  const setGenerateDataHistoria = async (data) => {
    const itemsHistory = [];
    if (data != null) {
      Object.keys(data).map((key) =>
        // itemsHistory.push({
        //   title: data[key]["inicio"],
        //   cardTitle: `Finalizado : ${data[key]["fin"]}`,
        //   media: {
        //     name: data[key]["etapa"],
        //     source: {
        //       url:
        //         "http://www.canaldenoticias.cl/noticias/images/idreg7525_logo2015.png"
        //     },
        //     type: "IMAGE"
        //   },
        //   cardSubtitle: `Etapa: ${data[key]["etapa"]}`,
        //   cardDetailedText: `Responsable: ${data[key]["responsable"]}`
        // })
        itemsHistory.push({
          title: `Etapa: ${data[key]["etapa"]}`,
          cardTitle: `Responsable: ${data[key]["responsable"]}`,
          cardSubtitle: `Fecha inicio : ${data[key]["inicio"]} | Fecha fin : ${data[key]["fin"]}`,
        })
      );
      setDataHistoria(itemsHistory);
    } else {
      setDataHistoria([]);
    }
  };

  useEffect(
    () => {
      window.gtag("event", recActivo.ux, /* ux */ {
        event_category: "access",
        event_label: recActivo.folio, /* folio */
      });
      if (user === null) {
        return history.push("/");
      }
      if (tramite == null) {
        getFases();
        getDetalleReclamo();
      }
    },
    // eslint-disable-next-line
    [user, recActivo, history]
  );

  return (
    <Fragment>

      {loading ? (
        <Spinner />
      ) : fases ? (
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          style={{
            backgroundImage: `url("https://rnpi.superdesalud.gob.cl/app/images/3.png")`,
          }}
        >
          <Grid item xs={10} sm={8} className={classes.section}>
            <Box pl={2} color={"rgb(97,97,97,0.9)"}>
              <h1
                style={{
                  fontSize: 22,
                  fontWeight: "bold",
                  textAlign: "Left",
                  paddingTop: "30px",
                  paddingLeft: "0px",
                  paddingBottom: "5px",
                }}
              >
                Trámite - {recActivo.folio} {/* folio */}
              </h1>

              <Paper>
                {width < 500 ? (
                  <>
                    {!(activeStep > 0) ? null : (
                      <Box pl={2} color={"rgb(97,97,97,0.9)"} style={{paddingTop:10}}>
                        <Stepper
                          alternativeLabel
                          activeStep={activeStep}
                          connector={<ColorlibConnector />}
                        >
                          <Step key={fases[activeStep].id}>
                            <StepLabel StepIconComponent={ColorlibStepIcon}>
                              {fases[activeStep].name}
                            </StepLabel>
                          </Step>
                        </Stepper>
                      </Box>
                    )}
                  </>
                ) : (
                  <Stepper
                  style={{paddingTop:10}}
                    alternativeLabel
                    activeStep={activeStep}
                    connector={<ColorlibConnector />}
                  >
                    {fases.map((fase, index) => (
                      <Step key={index}>
                        <StepLabel StepIconComponent={ColorlibStepIcon}>
                          {fase.name}
                        </StepLabel>
                      </Step>
                    ))}
                  </Stepper>
                )}
                <Grid item xs={12} sm={11}>
                  <Box flexDirection="row" pl={10}>
                    {tramite && tramite.recursos ? (
                      <>
                        {tramite.recursos.map((recurso, index) => (
                          <Box key={index}>
                            <RecursoItems recurso={recurso} key={index} />
                          </Box>
                        ))}
                        <h1
                          style={{
                            fontSize: 18,
                            fontWeight: "bold",
                            textAlign: "left",
                            paddingTop: "20px",
                          }}
                        >
                          Descripción del Trámite
                        </h1>
                        <Box
                          flexDirection="row"
                          pb={1}
                          style={{ textAlign: "justify" }}
                        >
                          {tramite.faseDescription}
                        </Box>
                        <Box>
                          <>
                            <h1 style={{ fontSize: 18, fontWeight: "bold", textAlign: "left", padding: 4, marginTop: 10 }}>Monitoreo</h1>
                            <Table style={{ padding: 4, marginTop: 0 }}>
                              <TableBody>

                                <StyledTableRow key={0}>
                                  <StyledTableCell style={{ padding: 4 }}><Typography color="textSecondary" gutterBottom variant="subtitle2">{'Solicitante:'} </Typography> </StyledTableCell>
                                  <StyledTableCell align="left" style={{ padding: 4 }}>{recActivo.usuario_solicitante==="" ? "N/A":recActivo.usuario_solicitante}</StyledTableCell>
                                </StyledTableRow>
                                <StyledTableRow key={1}>
                                  <StyledTableCell style={{ padding: 4 }}><Typography color="textSecondary" gutterBottom variant="subtitle2">{'Solicitud:'} </Typography> </StyledTableCell>
                                  <StyledTableCell align="left" style={{ padding: 4 }}>{recActivo.solicitud==="" ? "N/A":recActivo.solicitud}</StyledTableCell>
                                </StyledTableRow>
                                <StyledTableRow key={2}>
                                  <StyledTableCell style={{ padding: 4 }}><Typography color="textSecondary" gutterBottom variant="subtitle2">{'Observaciones:'} </Typography> </StyledTableCell>
                                  <StyledTableCell align="left" style={{ padding: 4 }}>{recActivo.observaciones==="" ? "N/A":recActivo.observaciones}</StyledTableCell>
                                </StyledTableRow>

                              </TableBody>
                            </Table>
                          </>
                        </Box>
                        <Box style={{ padding: "40px" }}>
                          <div align="right">
                            <table>
                              <tbody>
                                <tr>
                                  <td>
                                    {!tramite.printCertificate ? null : (
                                      <Button
                                        disableElevation
                                        onClick={() =>
                                          generateCertificado(
                                            tramite.cetificateTramite
                                          )
                                        }
                                        variant="contained"
                                        color="primary"
                                        className={classes.submit}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="#FFFFFF"
                                          stroke-width="1"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        >
                                          <path d="M15.475,6.692l-4.084-4.083C11.32,2.538,11.223,2.5,11.125,2.5h-6c-0.413,0-0.75,0.337-0.75,0.75v13.5c0,0.412,0.337,0.75,0.75,0.75h9.75c0.412,0,0.75-0.338,0.75-0.75V6.94C15.609,6.839,15.554,6.771,15.475,6.692 M11.5,3.779l2.843,2.846H11.5V3.779z M14.875,16.75h-9.75V3.25h5.625V7c0,0.206,0.168,0.375,0.375,0.375h3.75V16.75z"></path>
                                        </svg>{" "}
                                        Emitir Certificado
                                      </Button>
                                    )}
                                  </td>
                                  {isAnalista((user || {}).auth) ? (
                                    <td>
                                      {tramite.expedienteTipo === "reclamos_ip" ||
                                        tramite.expedienteTipo === "reclamos_if" ? (
                                        tramite.expedientePrint === true ? (
                                          <Button
                                            disableElevation
                                            onClick={() =>
                                              generateExpediente(
                                                tramite.expedienteTramite
                                              )
                                            }
                                            variant="contained"
                                            color="primary"
                                            className={classes.submit}
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="24"
                                              height="24"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              stroke="#FFFFFF"
                                              stroke-width="1"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            >
                                              <path d="M15.475,6.692l-4.084-4.083C11.32,2.538,11.223,2.5,11.125,2.5h-6c-0.413,0-0.75,0.337-0.75,0.75v13.5c0,0.412,0.337,0.75,0.75,0.75h9.75c0.412,0,0.75-0.338,0.75-0.75V6.94C15.609,6.839,15.554,6.771,15.475,6.692 M11.5,3.779l2.843,2.846H11.5V3.779z M14.875,16.75h-9.75V3.25h5.625V7c0,0.206,0.168,0.375,0.375,0.375h3.75V16.75z"></path>
                                            </svg>{" "}
                                            Ver Expediente
                                          </Button>
                                        ) : (
                                          <Button
                                            disableElevation
                                            variant="contained"
                                            color="secondary"
                                            className={classes.submit}
                                            disabled
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="24"
                                              height="24"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              stroke="#FFFFFF"
                                              stroke-width="1"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            >
                                              <path d="M15.475,6.692l-4.084-4.083C11.32,2.538,11.223,2.5,11.125,2.5h-6c-0.413,0-0.75,0.337-0.75,0.75v13.5c0,0.412,0.337,0.75,0.75,0.75h9.75c0.412,0,0.75-0.338,0.75-0.75V6.94C15.609,6.839,15.554,6.771,15.475,6.692 M11.5,3.779l2.843,2.846H11.5V3.779z M14.875,16.75h-9.75V3.25h5.625V7c0,0.206,0.168,0.375,0.375,0.375h3.75V16.75z"></path>
                                            </svg>{" "}
                                            No posee Expediente
                                          </Button>
                                        )
                                      ) : null}
                                    </td>
                                  ) : null}
                                </tr>
                              </tbody>
                            </table>

                            {/* <Modal
                              open={open}
                              onClose={handleClose}>
                              <Box sx={style}>
                                <TramitesHistoria recurso={tramite.faseHistoria} />
                              </Box>
                            </Modal> */}
                          </div>
                        </Box>
                        {isAnalista((user || {}).auth) ? (
                          tramite && tramite.faseHistoria ? (
                            <Accordion>
                              <AccordionSummary
                                expandIcon={<ExpandMore />}
                                classes={{ root: classes.titleAccordion }}
                              >
                                <svg
                                  className={{ root: classes.TimelineIcon }}
                                  xmlns="http://www.w3.org/2000/svg"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  width="24"
                                >
                                  <path d="M0 0h24v24H0z" fill="none" />
                                  <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
                                </svg>
                                <span className={classes.titleAccordionText}>
                                  Historia
                                </span>
                              </AccordionSummary>
                              <AccordionDetails>
                                {/* <div style={{ width: "100%", height: "95vh" }}>
                                                        <Chrono
                                                          items={dataHistoria}
                                                          mode="VERTICAL_ALTERNATING"
                                                          cardHeight={100}
                                                          scrollable={{ scrollbar: true }}
                                                          enableOutline
                                                        />
                                                      </div> */}
                                <TramitesHistoria
                                  recurso={tramite.faseHistoria}
                                />
                              </AccordionDetails>
                            </Accordion>
                          ) : null
                        ) : null}
                        <br></br>
                      </>
                    ) : (
                      <Grid item xs={12} sm={10}>
                        <Box>
                          <h3 style={{fontSize:14}}>No posee Recursos</h3>
                        </Box>
                      </Grid>
                    )}
                  </Box>
                </Grid>
              </Paper>
            </Box>
          </Grid>
        </Grid>
      ) : null}
      {!!url ? <RenderFile {...{ url, setUrl }} /> : null}
      {!!expediente ? <EmberFile {...{ expediente, setExpediente }} /> : null}
    </Fragment>
  );
};
export default TramitesDetails;

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    margin: "30px",
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  sectionTitle: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  sectionDetails: {
    marginLeft: theme.spacing(4),
    marginRight: theme.spacing(4),
  },
  titleAccordion: {
    margin: "5px 0px",
    BorderColor: "#0064AC",
    // backgroundColor: '#0064AC',
  },
  titleAccordionText: {
    fontSize: "18px",
    fontWeight: "bold",
    textAlign: "left",
    padding: 4,

    marginTop: "10px",
  },

  TimelineIcon: {
    color: "#FFFFFF",
    marginTop: "20px",
    marginRight: "8px",
    fontSize: "18px",
  },
  searchText: {
    flex: "0.8 0",
  },
  clearIcon: {
    "&:hover": {
      color: theme.palette.error.main,
    },
  },
}));
